import { useState } from 'react';
import Header from "./Header"
import Career from "./Career"
import Details from "./Details"

export default function Page({ profile, radar, careers, skills, stories, toggleCategory, toggleSkill, toggleCareer, toggleLanguage, style }) {
    const fullName = [
            profile.identity.firstname,
            profile.identity.lastname
        ].join(" ")

    return (
        <>
            <title>{ fullName }</title>

            <div style={style.profile}>
                <Header 
                    identity={ profile.identity }
                    networking={ profile.networking }
                    skills={ skills }
                    state={ profile.state }
                    radar={ radar }
                    toggleCategory={ toggleCategory }
                    toggleSkill={ toggleSkill }
                    careers={ careers }
                    style={ style }
                />
                <Career 
                    careers={ careers } 
                    toggleCareer={ toggleCareer }
                />
                <Details 
                    stories={ stories }
                    skills={ skills }
                />
            </div>
        </>
    )
}